export { default as useImageOnLoad } from './useImageOnLoad';
export * from './useImageOnLoad';
//# sourceMappingURL=index.js.map